import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { ComponentFields } from '@sitecore-jss/sitecore-jss-nextjs';

import { ContentAccessTypeItem } from 'src/types/ContentAccessTypeItem';
import { ContentDetailAccess } from 'src/types/ContentDetailAccess';

import { LoginFormFields } from 'src/components/account/Login/LoginFormFields';

import { parseAccessTypes } from './parseAccessTypes';

export function parseAccessLevelRouteFields(fields: ComponentFields | undefined): ContentDetailAccess | undefined {
	const accessTypes = parseAccessTypes(fields?.AccessType || []);
	return parse(accessTypes, fields);
}

export function parseAccessLevelContent(
	accessType: Array<ContentAccessTypeItem> | undefined,
	fields?: LoginFormFields
): ContentDetailAccess | undefined {
	const accessTypes = parseAccessTypes(accessType || []);
	return parse(accessTypes, fields);
}

function parse(
	accessTypes: Map<string, string> | null,
	fields: ComponentFields | LoginFormFields | undefined
): ContentDetailAccess | undefined {
	if (!accessTypes) {
		return undefined;
	}

	return {
		OpenAccess: {
			AllowAccess: accessTypes?.has(sitecoreIds.Items.OpenAccessContentAccessTypeId),
			Colour: fields?.RegisteredLoginBtnColour,
			Logo: fields?.RcnLearnLogo,
		},
		RegisteredUser: {
			AllowAccess: accessTypes?.has(sitecoreIds.Items.RegisteredUserContentAccessTypeId),
			Colour: fields?.RegisteredLoginBtnColour,
			Logo: fields?.RcnLearnLogo,
		},
		RcnMember: {
			AllowAccess:
				accessTypes?.has(sitecoreIds.Items.RcnMemberContentAccessTypeId) &&
				!accessTypes?.has(sitecoreIds.Items.RegisteredUserContentAccessTypeId),
			Colour: fields?.MemberLoginBtnColour,
			Logo: fields?.RcnLogo,
		},
		RcniPlusSubscriber: {
			AllowAccess:
				accessTypes?.has(sitecoreIds.Items.RcniPlusSubscriberContentAccessTypeId) &&
				!accessTypes?.has(sitecoreIds.Items.RegisteredUserContentAccessTypeId),
			Colour: fields?.SubscriberLoginBtnColour,
			Logo: fields?.RcniPlusLogo,
		},
	} as ContentDetailAccess;
}
